"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const page_section_1 = __importDefault(require("~components/page-section"));
const _service_1 = require("~service");
const products_1 = require("@phishtool/products");
const PricingSection = ({ community, professional, enterprise }) => ((0, jsx_runtime_1.jsx)(page_section_1.default, { id: "pricing", title: "Pricing", headerSpacer: ['x3', null, 'x6'], hasDivider: false, children: (0, jsx_runtime_1.jsx)(products_1.ProductComparison, { size: "large", community: community, professional: professional, enterprise: enterprise, useGetExchangeRates: _service_1.exchangeRateService.useGetExchangeRates }) }));
exports.default = PricingSection;
